import React from "react";

export default function Hero({ hero, logo }) {
  const h = hero || {};
  const primary = h.primaryCta || {};
  const secondary = h.secondaryCta || {};
  return (
    <section
      id="home"
      className="relative min-h-[100vh] w-full flex items-center justify-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${h.bgImage || ''})` }}
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white fade-up">
        <div className="flex justify-center mb-8">
          <img
            src={logo}
            alt="badge"
            className="w-24 h-24 md:w-28 md:h-28 rounded-full object-cover ring-2 ring-white/30"
          />
        </div>
        <h1 className="font-serif-display text-5xl md:text-7xl lg:text-[88px] leading-[1.05] mb-6">
          {h.title}
        </h1>
        <p className="text-base md:text-lg font-light tracking-wide opacity-90 mb-10">
          {h.subtitle}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          {primary.label && (
            <a
              href={primary.href || '#'}
              className="bg-[#a08862] hover:bg-[#8e7654] text-white text-[12px] tracking-tight-wide px-9 py-4 transition-colors duration-300"
            >
              {primary.label}
            </a>
          )}
          {secondary.label && (
            <a
              href={secondary.href || '#'}
              className="border border-white/80 hover:bg-white hover:text-[#2a2a2a] text-white text-[12px] tracking-tight-wide px-9 py-4 transition-colors duration-300"
            >
              {secondary.label}
            </a>
          )}
        </div>
      </div>
    </section>
  );
}
